module.exports = __webpack_public_path__ + "img/copy-icon.61e41692.svg";